module.exports = __webpack_public_path__ + "static/media/2.ecb8fa9c.svg";